import { render, staticRenderFns } from "./ChatSidebarWrapper.vue?vue&type=template&id=152738af&scoped=true"
import script from "./ChatSidebarWrapper.vue?vue&type=script&lang=js"
export * from "./ChatSidebarWrapper.vue?vue&type=script&lang=js"
import style0 from "./ChatSidebarWrapper.vue?vue&type=style&index=0&id=152738af&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "152738af",
  null
  
)

export default component.exports